// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3KETA","title":"AfterFrontImage_title__27GEB"};